import React, { useEffect, useRef } from "react";
import { useStatusInputContext } from "../StatusInputContextProvider";
import { useDropEditInputLayout } from "hooks/editInputDragAndDrop/useDropEditInputLayout/useDropEditInputLayout";
import Callout from "components/callout/Callout";
import "./editStatusInputLayout.scss";
import EditStatusInputRow from "./EditStatusInputRow";
import { useTranslation } from "react-i18next";

export default function EditStatusInputLayout() {
  const { t } = useTranslation();
  const statusInputContext = useStatusInputContext();

  const statusLayoutRef = useRef<HTMLDivElement>(null);
  const statusLayoutRowContainerRefs = useRef<HTMLDivElement[]>([]);

  const { drop, customDragLayer } = useDropEditInputLayout(
    statusLayoutRef,
    statusLayoutRowContainerRefs,
    statusInputContext.inputRowsContainerActions.update,
    statusInputContext.inputRowsContainer.updatedState,
  );

  useEffect(() => {
    if (statusInputContext.inputRowsContainer?.updatedState) {
      const numRows = Object.keys(statusInputContext.inputRowsContainer.updatedState).length;

      statusLayoutRowContainerRefs.current = statusLayoutRowContainerRefs.current.slice(0, numRows);
    }
  }, [statusInputContext.inputRowsContainer?.updatedState]);

  return (
    <>
      {statusInputContext.inputRowsContainer?.updatedState &&
      Object.keys(statusInputContext.inputRowsContainer.updatedState).length > 0 ? (
        <div className="status-edit-input-layout">
          <div
            ref={el => {
              drop(el);
              statusLayoutRef.current = el;
            }}
            className="status-registration-layout-rows"
          >
            {Object.keys(statusInputContext.inputRowsContainer.updatedState).map((row, index) => {
              const inputs = statusInputContext.inputRowsContainer.updatedState[row];
              const inputIds = inputs.map(input => input.id);
              const inputRowIdentifier = `[${inputIds.toString()}]`;

              return (
                <div ref={el => (statusLayoutRowContainerRefs.current[index] = el)} key={inputRowIdentifier}>
                  <EditStatusInputRow inputRow={row} inputs={inputs} />
                </div>
              );
            })}
            {customDragLayer}
          </div>
        </div>
      ) : (
        <Callout
          type={"info"}
          title={t("No Status Inputs")}
          content={t("You do not currently have any status inputs for this facility.  Please add a new input to this facility to get started.")}
        />
      )}
    </>
  );
}
